import { useTranslation } from "react-i18next";

export default function TrustBar() {
  const { t } = useTranslation();

  const stats = [
    { label: t("trust.entry"), sublabel: t("trust.entrySub"), detail: t("trust.entryDetail") },
    { label: t("trust.fx"), sublabel: t("trust.fxSub"), detail: t("trust.fxDetail") },
    { label: t("trust.yield"), sublabel: t("trust.yieldSub"), detail: t("trust.yieldDetail") },
    { label: t("trust.remote"), sublabel: t("trust.remoteSub"), detail: t("trust.remoteDetail") },
  ];

  return (
    <section className="w-full bg-paper border-y border-hairline">
      <div className="w-full">
        <div className="grid grid-cols-2 lg:grid-cols-4 border border-hairline">
          {stats.map((stat, i) => (
            <div
              key={stat.label}
              className={`
                p-6 md:p-10 text-center
                ${i === 0 ? "border-r border-b lg:border-b-0 border-hairline" : ""}
                ${i === 1 ? "border-b lg:border-r lg:border-b-0 border-hairline" : ""}
                ${i === 2 ? "border-r border-hairline" : ""}
              `}
            >
              <p className="font-serif text-2xl md:text-3xl font-semibold text-ink mb-1">
                {stat.label}
              </p>
              <p className="text-xs text-ink font-medium uppercase tracking-wider mb-1">
                {stat.sublabel}
              </p>
              <p className="text-xs text-ink/50 font-light">{stat.detail}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}